<template>
  <div>

    <table class="table table-hover" style="width:400px">
<!--      <thead class="thead-light">-->
<!--      <tr>-->
<!--        <th>標籤1</th>-->
<!--        <th>標籤2</th>-->
<!--        <th>標籤3</th>-->
<!--      </tr>-->
<!--      </thead>-->
      <tbody>
      <tr>
        <td class="text-left">
          App使用
        </td>
        <td class="text-left">

          今天使用人次 {{data.App_Today}}
        </td>
      </tr>

      <tr>
        <td class="text-left">

        </td>
        <td class="text-left">
          本周使用人次 {{data.App_ThisWeek}}
        </td>
      </tr>

      <tr>
        <td class="text-left">

        </td>
        <td class="text-left">
          本月使用人次 {{data.App_ThisMonth}}
        </td>
      </tr>

      <tr>
        <td class="text-left">
          個案人數
        </td>
        <td class="text-left">
          <router-link to="/MemberList">總共 {{data.Case_All}}</router-link> &nbsp;&nbsp;
           <router-link to="/MemberList?isFinish=true">已完成確認 {{data.Case_IsFinish}}</router-link>&nbsp;&nbsp;
          <router-link to="/MemberList?isFinish=false">未完成確認 {{data.Case_IsUnFinish}}</router-link>
        </td>
      </tr>

      <tr>
        <td class="text-left">

        </td>
        <td class="text-left">
          <router-link to="/MemberList?riskLevel=A">A級 {{data.Case_A}}</router-link>
        </td>
      </tr>

      <tr>
        <td class="text-left">

        </td>
        <td class="text-left">
          <router-link to="/MemberList?riskLevel=B">B級 {{data.Case_B}}</router-link>
        </td>
      </tr>

      <tr>
        <td class="text-left">

        </td>
        <td class="text-left">
          <router-link to="/MemberList?riskLevel=C">C級 {{data.Case_C}}</router-link>
        </td>
      </tr>

      <tr>
        <td class="text-left">

        </td>
        <td class="text-left">
          <router-link to="/MemberList?riskLevel=D">D級 {{data.Case_D}}</router-link>
        </td>
      </tr>
      <tr>
        <td class="text-left">
          待處理個案
        </td>
        <td class="text-left">

        </td>
      </tr>
      <tr v-for="(tag,index) in data.Tags" :key="index">
        <td class="text-left">

        </td>
        <td class="text-left">
          <router-link :to="'/CaseMagList?tag='+tag.Tag">{{tag.Tag}} {{tag.TagCount}}</router-link>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>/**

 **/
import apiTzsci from "./js/apiTzsci";


export default {
  //name: "index",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      data:{}
    };
  },
  methods: {
    async loadData() {
      let data=await apiTzsci.api_Admin_GetHome();

      this.data=data;
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>

</style>
